import { Function, Type, Task, Talk, Announcement, Note, Consultation } from '../Entities';
import { Post } from '../Entities/Chat/Post';

export enum FunctionTypes {
  Task = 'Task',
  Talk = 'Talk',
  Note = 'Note',
  Consultation = 'Consultation',
  Announcement = 'Announcement'
}

export namespace FunctionTypes {
  export function getInstance(type: string, initData: Partial<Type<Post>>): Function<Post> {

    const id: string = initData.id ? initData.id : '';
    const name: string = initData.name ? initData.name : '';

    if (FunctionTypes.Task === type) {
      return new Task(id, name, type);
    }
    if (FunctionTypes.Talk === type) {
      return new Talk(id, name, type);
    }
    if (FunctionTypes.Note === type) {
      return new Note(id, name, type);
    }
    if (FunctionTypes.Consultation === type) {
      return new Consultation(id, name, type);
    }
    if (FunctionTypes.Announcement === type) {
      return new Announcement(id, name, type);
    } 

    return new Type('', '', '');
  }
}